module.exports = __webpack_public_path__ + "static/media/stationary3.cbc9cf7e.jpg";